module.exports = __webpack_public_path__ + "fonts/NoirPro-SemiBold.1bc66a4b.woff";